import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';

/**
 * resolves custom page title
 * expects id parameter and data object with title set in route
 * and returns a custom title, which combines given entity id and localized title data
 * @param route current route
 * @param state current route state
 * @returns {string} custom title, which
 */
export const customTitleResolver: ResolveFn<string> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): string => {
    return buildCustomTitle( route );
};

/**
 * helper function, to contruct custom title for router
 * @param route current route object
 * @returns string representing the custom title
 */
export const buildCustomTitle = ( route: ActivatedRouteSnapshot ) => {
    const pageTitle = [ 'Scope Hub' ];
    pageTitle.unshift( route.data[ 'title' ] );

    const titleParams = [ 'instanceId', 'unlocodeId', 'organizationName', 'scopeCode' ];
    for ( const [ key, value ] of Object.entries( route.params ) ) {
        if ( titleParams.includes( key ) ) {
            pageTitle.unshift( value );
        }
    }

    const title = pageTitle.join( ' - ' );
    return title;
};
